export const isNewDocument = (fullName: string): boolean => {
    const containsPathRegex = /.*\\.*/;
    return !containsPathRegex.test(fullName);
};
